import { FC } from 'react';
import { Card } from './styles';
import { BasicCardProps } from './types';

export const BasicCard: FC<BasicCardProps> = ({
	children,
	variant,
	fitContent = false,
	isRoundedCorners = true,
	styles,
	show = true,
	onClick,
	className,
  bg
}) => {
	return (
		<Card
			$variant={variant}
			$fitContent={fitContent}
			$isRoundedCorners={isRoundedCorners}
			$border={styles?.border}
			$borderRadius={styles?.borderRadius}
			$borderTopLeftRadius={styles?.borderTopLeftRadius}
			$borderTopRightRadius={styles?.borderTopRightRadius}
			$padding={styles?.padding}
			$show={show}
      $bg={bg}
			onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined}
			onTouchStart={onClick}
			className={className}
		>
			{children}
		</Card>
	);
};
